import { useDispatch, useSelector } from "react-redux";
import { RootState } from "stores/application.store";
import { DialogAPIInfo, dialogStateActions } from "features/reducers/dialogState/dialogState";
import { DialogTracking } from "components/Dialog/components/DialogTracking.ts";
import { useState } from "react";

export interface OpenDialogState {
	dialogStatus: DialogTracking;
	dialogIndex?: number;
	dialogId?: string | null;
	dialogLeavePath?: string | null;
	dialogData?: any;
}

export const useDialog = () => {
	const dispatch = useDispatch();
	const dialogStatus = useSelector((state: RootState) => state.dialogState.dialogStatus);
	const dialogIndex = useSelector((state: RootState) => state.dialogState.dialogIndex);
	const dialogId = useSelector((state: RootState) => state.dialogState.dialogId);
	const dialogLeavePath = useSelector((state: RootState) => state.dialogState.dialogLeavePath);
	const dialogAPIInfo = useSelector((state: RootState) => state.dialogState.apiInfo);
	const dialogData = useSelector((state: RootState) => state.dialogState.dialogData);

	const [saveTruckErrorMessage, setSaveTruckErrorMessage] = useState<string>();

	const openDialog = (openDialogState: OpenDialogState) => {
		dispatch(dialogStateActions.setDialogStatus(openDialogState.dialogStatus));
		dispatch(dialogStateActions.setDialogIndex(openDialogState.dialogIndex));
		dispatch(dialogStateActions.setDialogId(openDialogState.dialogId));
		dispatch(dialogStateActions.setDialogLeavePath(openDialogState.dialogLeavePath));
		dispatch(dialogStateActions.setDialogData(openDialogState.dialogData));
	};

	const closeDialog = (clearAPIStatus?: boolean) => {
		dispatch(dialogStateActions.clearDialogStatus(clearAPIStatus ?? true));
	};

	const setDialogAPIInfo = (apiInfo: DialogAPIInfo | undefined) => {
		dispatch(dialogStateActions.setDialogAPIInfo(apiInfo));
	};

	return {
		dialogStatus,
		dialogIndex,
		dialogId,
		dialogLeavePath,
		dialogData,
		openDialog,
		closeDialog,
		setDialogAPIInfo,
		dialogAPIInfo,
		saveTruckErrorMessage,
		setSaveTruckErrorMessage
	};
};
